/**
 * @author  lijiancheng | lijiancheng@17guagua.com
 * @version 1.0 | 2015/10/9
 * @js作用说明 cookie相关操作
 * @param 参数说明
 * @example  使用示例
 */

export default {
	loginKey:{	//登陆cookie项
		accessToken: true,
		channelid: true,
		hasLogin: true,
		isNew: true,
		lgtime: true,
		loginType: true,
		mcheck: true,
		nick: true,
		oemid: true,
		openid: true,
		openkey: true,
		refreshToken: true,
		regTime: true,
		sourceType: true,
		uid: true,
		unionid: true,
		webToken: true,
		sessionid: true,
		port: true,
		streamID: true,
		tempid: true,
		tempmcheck: true,
		photo: true,
	},
    set: function(cookieKey, cookieValue, cookieOpts){
    	if(sessionStorage.getItem('isxiaoxiong')=='true' && this.loginKey[cookieKey]){
    		cookieKey = 'DL'+cookieKey;
    	}
        var arr = [];
        var d, t;
        var cfg = {
            'expire': null,
            'customExpire': null,
            'path': null,
            'domain': null,
            'secure': null,
            'encode': true
        };
        $.extend(cfg, cookieOpts);

//      if (cfg.encode == true) {
            cookieValue = encodeURI(cookieValue);
//      }
        arr.push(cookieKey + '=' + cookieValue);

        if (cfg.path != null) {
            arr.push('path=' + cfg.path);
        }
        if (cfg.domain != null) {
            arr.push('domain=' + cfg.domain);
        }
        if (cfg.secure != null) {
            arr.push(cfg.secure);
        }
        if (cfg.expire != null) {
            d = new Date();
            t = d.getTime() + cfg.expire * 3600000; //cfg.expire * 1小时
            d.setTime(t);
            arr.push('expires=' + d.toGMTString());
        }
        if(cfg.customExpire != null){
            arr.push('expires=' + cfg.customExpire.toGMTString());
        }
        
        document.cookie = arr.join(';');
    },
    get: function(cookieKey){
//      cookieKey = cookieKey.replace(/([\.\[\]\$])/g, '\\\$1');
//      var rep = new RegExp(cookieKey + '=([^;]*)?;', 'i');
//      var co = document.cookie + ';';
//      var res = co.match(rep);
//      if (res) {
//      		 return decodeURI(res[1])|| "";
//      }
//      else {
//          return null;
//      }
        if(sessionStorage.getItem('isxiaoxiong')=='true' && this.loginKey[cookieKey]){
    		cookieKey = 'DL'+cookieKey;
    	}
        var cookieKey = cookieKey.replace(/([\.\[\]\$])/g, '\\\$1');
        //var rep = new RegExp('(^;|)'+cookieKey + '=([^;]*)?;', 'ig');
        var rep = new RegExp("(^| )"+cookieKey+"=([^;]*)(;|$)", 'ig')
        var res = document.cookie.match(rep);
        if (res) {
            return decodeURI(res[0].replace(';', '').split('=')[1] || "");
        }
        else {
            return null;
        }
    },
    remove: function(cookieKey, cookieOpts){
    	if(sessionStorage.getItem('isxiaoxiong')=='true' && this.loginKey[cookieKey]){
    		cookieKey = 'DL'+cookieKey;
    	}
        cookieOpts = cookieOpts || {};
        cookieOpts.expire = -10;
        this.set(cookieKey, '', cookieOpts);
    }
};


// WEBPACK FOOTER //
// ./src/libs/cookie.js